import { RegisterOrder, CreateCustomerOrderFromOffer } from '../../../Services/BasketService'
import { useConfig } from '../../../Providers/ConfigProvider'
import { useAuth } from '../../../Providers/AuthProvider'
import { useOrder } from '../../../Providers/OrderProvider'
import { useWarehouse } from '../../../Providers/WarehouseProvider'
import useLogger from '../../../Components/BasketPage/Hooks/useLogger'
import { useCart } from '../../../Providers/CartProvider'
import { useCustomer } from '../../../Providers/CustomerProvider'
import { toast } from 'react-toastify'
import useCalculateTimeDiff from '../../../Hooks/useCalculateTimeDiff'
import useCheckCustomerHasPriceList from '../../../Components/BasketPage/Hooks/useCheckCustomerHasPriceList'
import { useOffers } from '../../../Providers/OffersProvider'
import { useDiscount } from '../../../Providers/DiscountProvider'

const useRegisterOrder = () => {
    const { logError } = useLogger()
    const { diffHoursFromNow } = useCalculateTimeDiff()
    const { api } = useConfig()
    const { authState, logout } = useAuth()
    const { orderInfo } = useOrder()
    const { selectedWarehouse, handleGetMacroRegionalWarehouseBySiteId, warehouses } = useWarehouse()
    const { basketTotalPriceGross } = useCart()
    const { handleGetCreditInfo } = useCustomer()
    const { checkCustomerHasPriceList } = useCheckCustomerHasPriceList()
    const { orderItemsFromOffer } = useOffers()
    const { voucher } = useDiscount()

    const handleRegisterOrder = async (offerNo, offerSiteId) => {
        var customerHasPriceList = true
        if (!offerNo && !offerSiteId) { //Nie sprawdzamy cennika gdy realizujemy zamowienie z oferty
            if (authState.user.isOperator) {
                customerHasPriceList = await checkCustomerHasPriceList(authState.custId)
            }
            if (!customerHasPriceList) {
                return 'Brak cennika'
            }
        }

        const customer = authState.selectedCustomerData ? authState.selectedCustomerData : authState.user.customerInfo[0]
        if (!orderInfo || !orderInfo.deliveryType || !orderInfo.authorizedPersons || !customer) {
            return null
        }

        if (orderInfo.payment === 'Limit kredytowy') {
            const creditInfo = await handleGetCreditInfo()
            if (!creditInfo || (creditInfo.remainCredit - basketTotalPriceGross < 0)) {
                return 'Brak limitu'
            }
        }

        const GetExpectedDeliveryTime = (expectedDeliveryTime) => {
            if (expectedDeliveryTime) {
                const [datePart] = expectedDeliveryTime.split(' ');
                return new Date(datePart)
            }
            else {
                return null
            }
        }
        try {
            let warehouseToRegisterOrder = await handleRedirectOrder(orderInfo.expectedDeliveryTime)
            let paymentType = handleGetPaymentType(orderInfo.payment)
            let deliveryType = orderInfo.deliveryType === 'Odbiór w hurtowni' ? 1 : 2
            const customerInfo = {
                Name: customer.name,
                ZipCode: customer.zipCode,
                City: customer.city,
                Street: customer.street,
                HouseNum: customer.houseNum,
                LocalNum: customer.localNum,
                Email: customer.email,
                Phone: customer.phone,
                Tax: customer.nip,
                Dpl: customer.dpl,
            }

            const deliveryAddress = {
                CourierId: 0,
                CourierName: '',
                Name: orderInfo.deliveryAddress.name,
                ZipCode: orderInfo.deliveryAddress.zipCode,
                City: orderInfo.deliveryAddress.city,
                Street: orderInfo.deliveryAddress.street,
                HouseNum: orderInfo.deliveryAddress.houseNum,
                LocalNum: orderInfo.deliveryAddress.localNum,
                PhoneNumber: orderInfo.deliveryAddress.phoneNumber,
                Email: orderInfo.deliveryAddress.email
            }

            let receiver = {
                name: orderInfo.authorizedPersons.name ? orderInfo.authorizedPersons.name : '',
                surname: orderInfo.authorizedPersons.surname ? orderInfo.authorizedPersons.surname : '',
                email: orderInfo.authorizedPersons.email ? orderInfo.authorizedPersons.email : '',
                phone: orderInfo.authorizedPersons.phoneNumber ? orderInfo.authorizedPersons.phoneNumber : '',
            }

            let orderingPersonName = authState.user.firstName ? authState.user.firstName : ''
            let orderingPersonSureName = authState.user.lastName ? authState.user.lastName : ''

            let orderingPerson = {
                name: `${orderingPersonName} ${orderingPersonSureName}`,
                phone: authState.user.phoneNumber ? authState.user.phoneNumber : '',
                email: authState.user.email ? authState.user.email : ''
            }
            var res
            if (offerNo && offerSiteId) { //Tryb zamówienia z oferty  
                try {
                    res = await CreateCustomerOrderFromOffer(api, authState.custId, warehouseToRegisterOrder.siteId, warehouseToRegisterOrder.whId, deliveryType, orderInfo.comment, GetExpectedDeliveryTime(orderInfo.expectedDeliveryTime),
                        customerInfo, deliveryAddress, receiver, offerNo, offerSiteId, authState.user.isOperator, authState.user.kod, orderItemsFromOffer, voucher, paymentType)
                } catch (e) {
                    if (e.response.status === 403) {
                        if (e.response.data.includes('Brak uprawnień')) {
                            toast.error('Brak uprawnień!')
                            return null
                        }
                        else { //konto niekatywne, automatyczne wylogowanie
                            logout(false, false)
                            return null
                        }
                    }
                }
            }
            else {
                try {
                    res = await RegisterOrder(api, authState.custId, warehouseToRegisterOrder.siteId, warehouseToRegisterOrder.whId, deliveryType, orderInfo.comment, GetExpectedDeliveryTime(orderInfo.expectedDeliveryTime),
                        customerInfo, deliveryAddress, receiver, paymentType, authState.user.kod, authState.user.isOperator, orderingPerson, voucher)
                } catch (e) {
                    if (e.response.status === 403) {
                        if (e.response.data.includes('Brak uprawnień')) {
                            toast.error('Brak uprawnień!')
                            return null
                        }
                        else { //konto niekatywne, automatyczne wylogowanie
                            logout(false, false)
                            return null
                        }
                    }
                }
            }
            const data = res.data
            if (!data || data === "" || data === " ") {
                return null
            }
            return data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleGetPaymentType = (text) => {
        switch (text) {
            case 'Zapłać w hurtowni przy odbiorze':
                return 'G'
            case 'Przelew tradycyjny':
                return 'P'
            case 'Limit kredytowy':
                return 'P'
            case 'Płatności on-line - Autopay':
                return 'O'
            case 'Płatności on-line - Elavon':
                return 'O'
            default:
                return 'P'
            //Płatności online będa - O
        }
    }

    const handleRedirectOrder = async (expectedDeliveryTime) => {
        var siteId = authState.selectedCustomerData ? authState.selectedCustomerData.siteId : authState.initialSiteId
        let warehousesInMacroRegional = warehouses.filter(w => w.siteId === siteId)

        if (selectedWarehouse && warehousesInMacroRegional.some(w => w.id === selectedWarehouse.id)) {
            const diffHours = await diffHoursFromNow(expectedDeliveryTime)
            if (diffHours < 24) { // 24h do teraz bez przekierowania, ten sam dzień
                return { siteId, whId: selectedWarehouse.id }
            }
            else { // Powyżej 24h przekierowujemy na magazyn centralny
                let macroRegionalWarehouse = await handleGetMacroRegionalWarehouseBySiteId(siteId)
                return { siteId, whId: macroRegionalWarehouse.id }
            }
        }
        else { //Inny magazyn niż magazyny z makroregionu, do którego jest przypisany. Ustawiamy centralny magazyn jego makroregionu            
            let macroRegionalWarehouse = await handleGetMacroRegionalWarehouseBySiteId(siteId)
            return { siteId, whId: macroRegionalWarehouse.id }
        }
    }

    return { handleRegisterOrder }
}

export default useRegisterOrder